(() => {
  const initCarousel = (root) => {
    const viewport = root.querySelector('[data-ipax-home-viewport]');
    const track = root.querySelector('[data-ipax-home-track]');
    const prevBtn = root.querySelector('[data-ipax-home-prev]');
    const nextBtn = root.querySelector('[data-ipax-home-next]');
    if (!viewport || !track || !prevBtn || !nextBtn) return;

    const slides = Array.from(track.children);
    if (slides.length <= 1) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      return;
    }

    const getStep = () => {
      const first = slides[0];
      if (!first) return viewport.clientWidth;
      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
      const atStart = viewport.scrollLeft <= 2;
      const atEnd = viewport.scrollLeft >= maxScroll;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');

      const needsNav = viewport.scrollWidth > viewport.clientWidth + 4;
      prevBtn.hidden = !needsNav;
      nextBtn.hidden = !needsNav;
    };

    const scrollByDir = (dir) => {
      viewport.scrollBy({ left: dir * getStep(), behavior: 'smooth' });
    };

    prevBtn.addEventListener('click', () => scrollByDir(-1));
    nextBtn.addEventListener('click', () => scrollByDir(1));
    viewport.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    updateButtons();
  };

  const boot = () => {
    document.querySelectorAll('[data-ipax-home-carousel]').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-ipax-home-carousel]')?.forEach(initCarousel);
  });
})();
